import { Http } from '@gamiphy/http';
import { AppReferral, LinkReferral, UserReferral } from '@gamiphy/bl/referrals/types';

export class ReferralApi {
  public static async getUserReferrals(userId?: string): Promise<UserReferral[]> {
    const response = await Http.get<userReferralsResponse>({
      url: '/v2/user-referrals',
      query: {
        user: userId,
      },
    });
    return response.data.userReferrals;
  }

  public static async createAppReferral(referral: Omit<AppReferral, 'id' | 'app' | 'enabled'>): Promise<AppReferral> {
    const response = await Http.post<CreateAppReferralResponse>({
      url: '/v2/referrals',
      payload: referral,
    });
    return response.data.referral;
  }

  public static async getReferral(): Promise<AppReferral[]> {
    const response = await Http.get<GetAppReferralResponse>({
      url: '/v2/referrals',
    });
    return response.data.referrals;
  }

  public static async updateReferralApp(id: string, data: Partial<AppReferral>): Promise<AppReferral> {
    const response = await Http.patch<UpdateAppReferralResponse>({
      url: `/v2/referrals/${id}`,
      payload: data,
    });
    return response.data.referral;
  }
}

export type referAFriendByEmailRequest = {
  name: string,
  email: string
}

export type referAFriendByEmailResponse = {
  userReferral: UserReferral
}

export type userReferralsResponse = {
  userReferrals: UserReferral[]
}

export type userReferralLinkResponse = {
  linkReferral: LinkReferral
}

export type CreateAppReferralResponse = {
  referral: AppReferral,
}

export type GetAppReferralResponse = {
  referrals: AppReferral[],
  count: number
}

export type UpdateAppReferralResponse = {
  referral: AppReferral,
}
